// src/components/TechCard.js
import React from 'react';
import { GlowingEffect } from './border-effect/GlowingEffect';

const TechCard = ({ icon, name, index }) => {
  return (
    <div
      className="relative bg-[#242424] w-full sm:w-[160px] h-[140px] flex flex-col items-center justify-center
                 rounded-lg border border-transparent transition-all duration-300 "
      // data-aos="fade-up"
      // data-aos-delay={index * 100}
      // data-aos-duration="1000"
      // data-aos-easing="ease-in-out"
    >
      <GlowingEffect
        blur={0}
        borderWidth={2}
        spread={80}
        glow={true}
        disabled={false}
        proximity={64}
        inactiveZone={0.01}
      />
      <div className="relative z-10 text-6xl mb-2">{icon}</div>
      <p className="relative z-10 text-sm font-medium">{name}</p>
    </div>
  );
};

export default TechCard;
